import { fromJS } from "immutable"
import { v4 as uuidv4 } from 'uuid';
import actionTypes from "../../actions/actionTypes"


const getInitState = () => {
    return fromJS({
        items: [],
    })
}

const isItemType = (itemType, action) => action.payload.itemType == itemType

const newslettersElementsReducer = itemType => (state = getInitState(), action) => {

    const onCreateItem = (state, action) => {
        if(!isItemType(itemType, action)) {
            return state 
        } else {
            const id = uuidv4()

            return state.setIn(['items', id], fromJS(action.payload.itemData))
        }
    }

    const onUpdateItem = (state, action)  => {
        if(!isItemType(itemType, action)) {
            return state
        }  else {
            return state.setIn(['items', action.payload.itemData.id], fromJS(action.payload.itemData))
        }
    }

    const onDeleteItem = (state, action) => {
        if(!isItemType(itemType, action)) {
            return state
        } else {
            return state.deleteIn(['items', action.payload.itemId])
        }
    }
    
    switch(action.type)  {
        case actionTypes.NEWSLETTER_CREATE_ITEM:
            return onCreateItem(state, action)
        case actionTypes.NEWSLETTER_UPDATE_ITEM:
            return onUpdateItem(state, action)
        case actionTypes.NEWSLETTER_DELETE_ITEM: 
            return onDeleteItem(state, action)
        default:
            return state
    }
}

export default newslettersElementsReducer